<div class="hts-assistant" [class.hts-assistant--readonly]="vm.isReadonly">
  <div class="hts-assistant__header" *ngIf="isShowHeader">
    <div class="hts-assistant__title">{{ titleKey | translate }}</div>
    <span class="hts-assistant__ro-chip" *ngIf="isShowReadonlyChip">
      <i class="fa fa-eye" aria-hidden="true"></i>
      {{ "HTS_ASSISTANT.READ_ONLY_CHIP" | translate : { count: vm.messagesCount } }}
    </span>
    <div class="hts-assistant__close" (click)="onClose()">×</div>
  </div>

  <div class="hts-assistant__count" *ngIf="isShowHeaderCount" [class.hts-assistant__count--clear]="isAllValidated">
    <span *ngIf="!isAllValidated">
      {{ "HTS_ASSISTANT.HEADER_NEED_CLASSIFICATION" | translate : { count: needsClassificationCount, total: headerTotal } }}
    </span>
    <span *ngIf="isAllValidated">{{ "HTS_ASSISTANT.HEADER_ALL_VALIDATED" | translate }}</span>
  </div>

  <div class="hts-assistant__progress" *ngIf="isShowStepper">
    <div class="hts-assistant__progress-bar">
      <span
        class="hts-assistant__progress-segment"
        *ngFor="let line of lines; let i = index"
        [class.hts-assistant__progress-segment--done]="i <= selectedIndex"
      ></span>
    </div>
    <span class="hts-assistant__progress-label">
      {{ "HTS_ASSISTANT.ITEM_OF" | translate : { index: selectedIndex + 1, total: lines.length } }}
    </span>
    <button
      type="button"
      class="hts-assistant__eye"
      *ngIf="isShowPanelEye"
      [class.hts-assistant__eye--active]="isPanelOpen"
      nz-tooltip
      nzTooltipPlacement="left"
      [nzTooltipTitle]="panelEyeLabelKey | translate"
      [attr.aria-label]="panelEyeLabelKey | translate"
      (click)="togglePanel()"
    >
      <i class="fa fa-eye" aria-hidden="true"></i>
    </button>
    <button
      type="button"
      class="hts-assistant__eye"
      *ngIf="isShowDoOverButton"
      nz-tooltip
      nzTooltipPlacement="left"
      [nzTooltipTitle]="doOverTooltipKey | translate"
      [attr.aria-label]="doOverTooltipKey | translate"
      (click)="onToggleDoOver()"
    >
      <i *ngIf="!vm.isShowDoOver" class="fa fa-eye" aria-hidden="true"></i>
      <i *ngIf="vm.isShowDoOver" class="fa fa-undo" aria-hidden="true"></i>
    </button>
  </div>

  <div class="hts-assistant__panel-backdrop" *ngIf="isPanelOpen" aria-hidden="true" (click)="closePanel()"></div>
  <div class="hts-assistant__panel" *ngIf="isShowPanel">
    <ng-template [dynamic-component]="panelComponent" [inputs]="panelInputs" [outputs]="panelOutputs"></ng-template>
  </div>

  <!-- the dismissed suggestions stay one click away (#13517); the panel eye / do-over live in the progress row above -->
  <div class="hts-assistant__suggestions-bar" *ngIf="vm.isSuggestionsToggle">
    <span class="hts-assistant__suggestions-note">{{ "HTS_ASSISTANT.SUGGESTIONS_DISMISSED" | translate }}</span>
    <button
      type="button"
      class="hts-assistant__eye"
      [class.hts-assistant__eye--active]="vm.isSuggestionsOverlay"
      nz-tooltip
      nzTooltipPlacement="left"
      [nzTooltipTitle]="suggestionsToggleKey | translate"
      [attr.aria-label]="suggestionsToggleKey | translate"
      (click)="onToggleSuggestions()"
    >
      <i class="fa fa-lightbulb-o" aria-hidden="true"></i>
    </button>
  </div>

  <!-- everything from here to the composer is what the lock overlay covers; header, progress row and Back / Next stay live -->
  <div class="hts-assistant__body">
    <div class="hts-assistant__lock-overlay" *ngIf="isAssistantLocked" role="status">
      <div class="hts-assistant__lock">
        <div class="hts-assistant__lock-title">{{ lockTitleKey | translate }}</div>
        <div class="hts-assistant__lock-text">{{ lockTextKey | translate : lockTextParams }}</div>
        <div class="hts-assistant__lock-actions" *ngIf="isVerifiedLock">
          <button
            type="button"
            class="btn btn-square btn-primary hts-assistant__lock-button"
            [disabled]="vm.isBusy"
            (click)="onStartConversation()"
          >
            {{ "HTS_ASSISTANT.LOCK_START_CONVERSATION" | translate }}
          </button>
        </div>
      </div>
    </div>

    <p class="hts-assistant__subtitle" *ngIf="isShowQuickQuestionsHint">{{ "HTS_ASSISTANT.QUICK_QUESTIONS_HINT" | translate }}</p>

    <div class="hts-assistant__empty" *ngIf="isShowHistoryEmpty">
      {{ historyEmptyKey | translate }}
    </div>

    <div class="hts-assistant__product" *ngIf="!isShowHistoryEmpty" [attr.title]="vm.description || null">
      <span class="hts-assistant__product-text">
        <span class="hts-assistant__product-label">{{ "HTS_ASSISTANT.PRODUCT" | translate }} —</span>
        <span class="hts-assistant__product-value" *ngIf="vm.description">{{ vm.description }}</span>
        <span class="hts-assistant__product-empty" *ngIf="!vm.description">{{ "HTS_ASSISTANT.NO_DESCRIPTION" | translate }}</span>
      </span>
      <!-- standalone hosts: the line panel's eye lives here (the Validate view keeps it in the progress row above) -->
      <button
        type="button"
        class="hts-assistant__eye"
        *ngIf="isShowProductEye"
        [class.hts-assistant__eye--active]="isPanelOpen"
        nz-tooltip
        nzTooltipPlacement="left"
        [nzTooltipTitle]="panelEyeLabelKey | translate"
        [attr.aria-label]="panelEyeLabelKey | translate"
        (click)="togglePanel()"
      >
        <i class="fa fa-eye" aria-hidden="true"></i>
      </button>
    </div>

    <div class="hts-assistant__status" *ngIf="isShowStatusNote" [class.hts-assistant__status--validated]="isSelectedLineValidated">
      <ng-container *ngIf="!isSelectedLineRemoved">
        <app-hts-line-status-chip
          [status]="selectedLine.status"
          [reasonKey]="selectedLine.reasonKey"
          [reasonParams]="selectedLine.reasonParams"
        ></app-hts-line-status-chip>
        <span class="hts-assistant__status-reason">{{ selectedLine.reasonKey | translate : selectedLine.reasonParams }}</span>
      </ng-container>
      <ng-container *ngIf="isSelectedLineRemoved">
        <span class="hts-assistant__removed-chip">
          <i class="fa fa-trash-o" aria-hidden="true"></i>
          {{ "HTS_ASSISTANT.REMOVED_LINE" | translate }}
        </span>
        <span class="hts-assistant__status-reason">{{ "HTS_ASSISTANT.REASON_LINE_REMOVED" | translate }}</span>
      </ng-container>
    </div>

    <div class="hts-assistant__notice" *ngIf="isShowNotice" [class.hts-assistant__notice--error]="vm.notice.isError">
      <span>{{ vm.notice.textKey | translate : vm.notice.params }}</span>
      <button type="button" class="hts-assistant__notice-close" (click)="onDismissNotice()">×</button>
    </div>

    <div class="hts-assistant__loading" *ngIf="vm.isLoading">
      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    </div>

    <div class="hts-assistant__empty" *ngIf="isShowEmptyReadonly">
      {{ "HTS_ASSISTANT.NO_CONVERSATIONS" | translate }}
    </div>

    <!-- similar products the company classified before: insert one, or dismiss and let the assistant ask (#13517) -->
    <div class="hts-assistant__suggestions" *ngIf="vm.isSuggestionsStep">
      <ng-container *ngTemplateOutlet="suggestionsList"></ng-container>
      <p class="hts-assistant__suggestions-hint">{{ suggestionsHintKey | translate }}</p>
      <button type="button" class="hts-assistant__suggestions-dismiss" [disabled]="isDismissDisabled" (click)="onDismissSuggestions()">
        {{ suggestionsDismissKey | translate }}
      </button>
    </div>

    <div class="hts-assistant__suggestions-overlay" *ngIf="vm.isSuggestionsOverlay">
      <ng-container *ngTemplateOutlet="suggestionsList"></ng-container>
      <button type="button" class="hts-assistant__suggestions-dismiss" (click)="onToggleSuggestions()">
        {{ "HTS_ASSISTANT.SUGGESTIONS_HIDE" | translate }}
      </button>
    </div>

    <app-hts-assistant-thread
      *ngIf="!vm.isSuggestionsStep"
      [items]="vm.threadItems"
      [isHideCarried]="isHideCarriedNotes"
      [isReadonly]="vm.isReadonly"
      [isBusy]="vm.isBusy"
      [isLocked]="isAssistantLocked"
      (insert)="onInsert($event)"
      (saveToCatalog)="onSaveToCatalog($event)"
      (startOver)="onStartOver()"
    ></app-hts-assistant-thread>

    <div class="hts-assistant__footer" *ngIf="isShowFooter">
      <app-hts-assistant-composer
        [isDisabled]="isComposerDisabled"
        [maxLength]="composerMaxLength"
        (send)="onSend($event)"
      ></app-hts-assistant-composer>
    </div>
  </div>

  <div class="hts-assistant__stepper" *ngIf="isShowStepper">
    <button type="button" class="hts-assistant__step hts-assistant__step--back" [disabled]="isPrevDisabled" (click)="onPrev()">
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
      {{ "BUTTON.BACK" | translate }}
    </button>
    <button type="button" class="hts-assistant__step hts-assistant__step--next" [disabled]="isNextDisabled" (click)="onNext()">
      {{ "LABELS.NEXT" | translate }}
      <i class="fa fa-arrow-right" aria-hidden="true"></i>
    </button>
  </div>

  <ng-template #suggestionsList>
    <div class="hts-assistant__suggestions-title">
      <i class="fa fa-magic" aria-hidden="true"></i>
      {{ "HTS_ASSISTANT.SUGGESTIONS_TITLE" | translate }}
    </div>
    <!-- a verified line: its own code first, marked as current (no Insert) -->
    <app-hts-code-card
      *ngIf="vm.currentSuggestion"
      class="hts-assistant__suggestion"
      [suggestion]="vm.currentSuggestion"
      [isCurrent]="true"
    ></app-hts-code-card>
    <app-hts-code-card
      *ngFor="let suggestion of vm.suggestions; trackBy: trackBySuggestion"
      class="hts-assistant__suggestion"
      [suggestion]="suggestion"
      [isShowInsert]="true"
      [isShowSuggestionSource]="true"
      [isInserting]="vm.confirmingHts === suggestion.htsNumber"
      (insert)="onConfirmSuggestion(suggestion)"
    ></app-hts-code-card>
  </ng-template>

  <confirm-modal
    [isOpen]="isShowUnsavedModal"
    [title]="'FORM_LABEL.DO_YOU_WANT_TO_SAVE_CHANGES'"
    [description]="'LABELS.CHANGES_WILL_BE_LOST'"
    [declineText]="'HTS_ASSISTANT.UNSAVED_STAY'"
    [acceptText]="'HTS_ASSISTANT.UNSAVED_LEAVE'"
    (decline)="onUnsavedStay()"
    (accept)="onUnsavedLeave()"
  ></confirm-modal>
</div>
